<template>
  <component
    :is="data.id"
    :data="data"
  />
</template>

<script>
import Simple from '@/components/blocks/custom/simple';

export default {
  name: 'Custom',
  components: {
    Simple,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

</style>
